module.exports = __webpack_public_path__ + "img/hand_up.2b3a0a75.svg";